//@flow
//
// Reusable checkbox component
//
// Example usage:
//
//   <Checkbox
//     className="make-default-payment-method"
//     label="Make default payment method" // label for the checkbox
//     checked={this.props.checked} // set the default state
//     setCheckboxState={this.props.setDefaultPaymentMethod}
//   />

import React from 'react';

type Props = {
  className:string,
  label:string,
  name:string,
  id?:string,
  checked:boolean,
  setCheckboxState:(state:boolean)=>void,
};

type State = {
  checked:boolean,
};

export default class Checkbox extends React.Component<Props, State> {
  constructor(props:Props) {
    super(props);

    this.state = {
      checked: props.checked,
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps:Props) {
    if (nextProps.checked !== this.props.checked) {
      this.setState({ checked: nextProps.checked });
    }
  }

  toggleCheckbox = () => {
    const state = !this.state.checked;
    this.setState({
      checked: state,
    });

    if (this.props.setCheckboxState) {
      this.props.setCheckboxState(state);
    }
  };

  getClassName():string {
    const checked = this.state.checked ? ' checked' : '';
    return `${this.props.className}${checked}`;
  }

  render() {
    return (
      <div className={this.getClassName()} onClick={this.toggleCheckbox}>
        <label htmlFor={this.props.name}>
          <input
            tabIndex="0"
            aria-checked={this.state.checked}
            id={this.props.id || this.props.name}
            type="checkbox"
            name={this.props.name}
            defaultChecked={this.state.checked}
          />
          <span className="label">{this.props.label}</span>
        </label>
      </div>
    );
  }
}
